/**
 * Action for Save Maintenance
 */
export enum saveMaintenance {
  SAVE_MAINTENANCE_REQUEST = 'SAVE_MAINTENANCE_REQUEST'
}
